import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { styled } from '@mui/system'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import AddCustomerbox from './Addcustomer';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import Columnsettings from './Columnsettings';
import SettingsIcon from '@mui/icons-material/Settings';
import Checkbox from '@mui/material/Checkbox'; 
import ReactToPrint from 'react-to-print';
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
  },
}));
const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  };
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class AdminCustomer extends Component {
    constructor(props) {
    super(props);
      this.state = {redirect: false,  disablecopyicon:true,
      cuid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,customerdata:[],
	  order:'desc' ,orderBy:'',titles:'',countrydata:[],countrylabel:'Select Country',Checkbox:0,iconslist:false,ColumnData:[],allchecked:false,cuides:'',selectedcount:0,totalrecords:0,
      }
       this.updatecustomerParent = this.updatecustomerParent;
	}
	updatecustomerParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage); 
    this.updateColumnssetting=this.updateColumnssetting; 
	}
	updateColumnssetting = (text) => 
	{
        this.ColumheadervendorbillApi();
	}
	ColumheadervendorbillApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=11&cc_isdisplay=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			  colcount:parseInt(resp.data[0].count),
			});
     }
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=11&cc_isdisplay=1')
  .then(resp => {  	
				if(resp.data.length>0){
						this.setState({  
						  ColumnData: resp.data,  
						   colcount:parseInt(resp.data[0].count),
						});
				 }
	     });
	 }
    });
}
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,customerdata:[]
    });
}
	componentWillMount() {
	document.title = "Customer Details";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 this.apicall(this.state.page,this.state.rowsPerPage);
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
	         let strname="Customers";
	 this.props.parentdasCallback(
            strname+"~"
        );
	  localStorage.setItem("page",this.state.rowsPerPage)
} 
 PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=4')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
        this.apicall(this.state.page,this.state.rowsPerPage);
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
handleClickSearch=()=>{   
  this.apicall(this.state.page,this.state.rowsPerPage); 
} 
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
   this.setState({ Checkbox: event.target.Checkbox });
 }
apicall(page,rowsPerPage){
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage+'&cu_cmp_id='+localStorage.getItem("ISIcmpid")+'&cu_contactname='+this.state.titles)
  .then(resp => {  
    if(resp.data.length>0){
			this.setState({  
			  customerdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   totalrecords:parseInt(resp.data[0].count),
		    });
			let copy=[50, 100, 150, 200, 250]	;
	  this.setState({rowsPaging:copy});
     }
	 else{
		   this.setState({customerdata:[],totaldata:0});
	 }
 this.ColumheadervendorbillApi();
    });
}
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage)});
  };  
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
  }; 
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
  });
};
      employeeDelete(cuid){  
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('cu_id',cuid)
	  formData.append('userid',localStorage.getItem("ISIuserid"))	   
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
    this.apicall(this.state.page,this.state.rowsPerPage); 
            });
 }
      }
	    HandleAllcheckbox=()=>{
        var studArray = this.state.customerdata;
        var subnewRow="";
        this.setState({allchecked:!this.state.allchecked},() => {
        if(this.state.allchecked===false)
                 {
                  studArray.map((rowssub,j) => {
                  rowssub.isseleceted = "0" ;
                                 });
                 }
				 else if(this.state.allchecked===true)
                         {
                            studArray.map((rowssub, j) => {
                              rowssub.isseleceted = "1" ;
                           });
						 }
				this.setState({customerdata:studArray},()=>{
				const selectedItems= this.state.customerdata.filter(item => item.isseleceted==="1")
                this.setState({selectedcount:selectedItems.length});
                const selectedIds = selectedItems.map(item => item.cu_id);
                const selectedIdsString = selectedIds.join(',');
                  this.setState({cuides:selectedIdsString},()=>{
                        if(this.state.cuides!=="")
                          {
                         this.setState({iconslist:true});
                          }
                          else
                          {
                                   this.setState({iconslist:false});
                          }   
                  if (selectedIds.length >= 2) 
				        {
                         this.setState({disablecopyicon: false,});
                        } 
                    else{
                         this.setState({disablecopyicon:true });
                        }
                  });
           });
      }); 
  } 
HandleCheckbox=(id,rowsd)=>{
 const updatedArray=[...this.state.customerdata];
          if(updatedArray[rowsd].isseleceted==="0")
          {
                  updatedArray[rowsd].isseleceted = "1" ;
          }
		  else
          {
          updatedArray[rowsd].isseleceted = "0" ;
          }
        this.setState({customerdata:updatedArray,},()=>{
        const selectedItems= this.state.customerdata.filter(item => item.isseleceted==="1")
                 this.setState({selectedcount:selectedItems.length});
				 const selectedIds = selectedItems.map(item => item.cu_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({cuides:selectedIdsString},()=>{
                          if(this.state.vcnidies!=="")
                          {
                         this.setState({iconslist:true});
                          }
                          else
                          {
                              this.setState({iconslist:false});
                          }
                    });
                 if (selectedItems.length >= 2) {
         this.setState({disablecopyicon: false });
         } 
                   else{
                         this.setState({disablecopyicon: true });
                       }
          }) ;
  }
	onClickBulkdelete(){
	const idsArray = this.state.cuides.split(",").filter(id=>id.trim() !==""); 
     let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('cu_id',this.state.cuides)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
		 }
  }
	  OnSelectSendEmail()
  {
	    var formData = new FormData(); 
		formData.append('action','sendemail')	
		formData.append('cu_id',this.state.cuides)
		formData.append('cu_cmp_id',localStorage.getItem("ISIcmpid"))
		axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
		}).then(res =>{
						 this.apicall(this.state.page,this.state.rowsPerPage); 
					  });
   }
      Customeraddbox(val){
        this.setState({ cuid: val });  
         setTimeout(() => this.refs.AddCustomerbox.handleClickOpen(),500);
      }
	  addcheckbox(){
     setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);
       }
	     addprintbox(){
    setTimeout(() => this.refs.PrintBox.handleClickOpen(),500);
    }
ActiveInActiveStatusUpdate(cuid, activestatus) {
    let message;
    if (activestatus === 1) {
        message = window.confirm("Do you really want to activate?");
    } else if (activestatus === 0) {
        message = window.confirm("Do you really want to deactivate?");
    }
    if (message === true) {
        const formData = new FormData();
        formData.append('action', 'ActiveStatus');
        formData.append('strid', cuid);
        formData.append('activestatus', activestatus);
        formData.append('strpage', 1);
        formData.append('userid', localStorage.getItem("ISIuserid"));
        axios.post(localStorage.getItem("ISIurl") + "ajaxcustomer.php", formData)
            .then(res => {
                this.apicall(this.state.page, this.state.rowsPerPage);
            })
    }
}
render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
 const { children, value, index, ...other } = this.props;
  return (
<React.Fragment>
   <div className="searchbox">
  <ul>
   <li><TextField
  className="txtbox"
  value={this.state.selectedcount + " of " + this.state.totalrecords + " selected"}
  readOnly
/>
</li>
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"  className="txtbox"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Title"
            name="titles" onChange={this.myChangeHandler}
          /></p></li>
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Customeraddbox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		</ul>
</div>		
<div className="clear"></div>		
{this.state.iconslist===true && (
<div className="iconlistprint">
<p>
<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint()}}/>
  </IconButton>
</Tooltip>
<Tooltip title="Email" placement="top">
  <IconButton>
   <EmailTwoToneIcon onClick={()=>{this.OnSelectSendEmail()}}/>
  </IconButton>
</Tooltip>
{this.state.disablecopyicon === true && (
  <a href={'/#/Addvendorcreditnote?vcnid='+this.state.vcnidies+'&copy=1'} >
    <Tooltip title="Copy" placement="top">
      <IconButton>
        <ContentCopyTwoToneIcon />
      </IconButton>
    </Tooltip>
  </a>
)}
<Tooltip title="Delete" placement="top">
  <IconButton>
 <DeleteIcon onClick={()=>{this.onClickBulkdelete()}} />
  </IconButton>
</Tooltip>
 </p>
</div>	
	)}
<Columnsettings 
ref="Columnsettings"  
pageval={11}
updateDonenew={this.updateColumnssetting}
/>
<PrintBox ref="PrintBox" childcols={this.state.ColumnData} cuides={this.state.cuides}/>
<AddCustomerbox ref="AddCustomerbox" id={this.state.cuid}  parentcustomerinsert={this.updatecustomerParent}/>
<Paper className={useStyles.root}>
<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}>   <SettingsIcon /> </span>
        </div>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
  {this.state.totaldata!==0 && (
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'white', 
         '&.Mui-checked': {
            color: 'white', 
        },
    }}
              /> 	
			</TableCell>
		  )}
  		{this.state.ColumnData.map((col,i) => {  
           return ( 
		    <TableCell>
			{col.cc_displayname}
			 </TableCell>
		   )
         })}		
		 <TableCell></TableCell>
                      </TableRow></TableHead>
                      <TableBody>
                     {this.state.customerdata.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
 <TableCell>{item.isseleceted==="0" && (
        <Checkbox
         onChange={()=>{this.HandleCheckbox(item.cu_id,index)}}
         inputProps={{ 'aria-label': 'controlled' }}
		      sx={{'&.Mui-checked': {
            color: 'gray', 
                },
                }}
        /> 
      )}{item.isseleceted==="1" && (
        <Checkbox
      checked
      onChange={()=>{this.HandleCheckbox(item.cu_id,index)}}
	       sx={{ '&.Mui-checked': {
            color: 'gray', 
            },
          }}
     /> 
     )}</TableCell>
{this.state.ColumnData.map((cols,i) => { 
	let colsname	=  cols.cc_columnname; 
	return ( <React.Fragment>
	<TableCell><span><a className="link" href={"#/Customerviewmore?cuid="+item.cu_id+""}>{item[""+colsname+""]}</a></span></TableCell>
			</React.Fragment>	);
					})}
<TableCell align="left">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Customeraddbox(item.cu_id)}} endIcon={<EditIcon />}>
Edit
</Button>
&nbsp;&nbsp;
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.employeeDelete(item.cu_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
&nbsp;&nbsp;
{item.cu_isactive === "1" && (
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.ActiveInActiveStatusUpdate(item.cu_id,0)}} >
   Active
</Button>
)}
{item.cu_isactive === "0" && (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.ActiveInActiveStatusUpdate(item.cu_id,1)}} >
  In Active
</Button>
)}
 </TableCell>
 </TableRow>
 </React.Fragment>	
);
					})}
					{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
                      </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage} 
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
 </React.Fragment> 
  );
}
}
  export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  CustomerArray:[],
    };
  }
 handleClickPrint = () => {
this.GetCustomerBYIdes(this.props.cuides)
};
 GetCustomerBYIdes(id){
axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&cu_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  CustomerArray: resp.data,  
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
			});
     }
	  else{
		   this.setState({CustomerArray:[]});
	 }
    });
}
  render() {
 return (
	 <React.Fragment>
	 <div className="printmod">
	<div ref={el => (this.componentRef = el)} >
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
		   {this.props.childcols.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.CustomerArray.map((item,index) => {  
           return ( 
 <TableRow key={index} >
{this.props.childcols.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
<TableCell>{item[""+colsname+""]}</TableCell>
			</React.Fragment>	);
					})}
 </TableRow>
	);	})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
 ); 
 }
}